<template>
  <div class="container">
    <div class="header-title">
      <el-button type="primary" size="mini" @click="moduleuploadDialog = true">上传识别模块</el-button>
      <el-button type="primary" size="mini" @click="getApiList">刷新</el-button>
    </div>
    <vvTable
      :data="moduleList"
      :height="700"
      :config="tableConfig">
      <template slot-scope="scope" slot="version_desc_slot">
        {{scope.row.version_desc ? scope.row.version_desc : '-'}}
      </template>
      <template slot-scope="scope" slot="date_slot">
        {{scope.row.add_ts | tsToDate}}
      </template>
      <template slot-scope="scope" slot="desc_slot">
        {{scope.row.desc ? scope.row.desc : '-'}}
      </template>
      <template slot-scope="scope" slot="state_slot">
        <el-tag type="success" v-if="scope.row.is_published === '1'" size="mini">已发布</el-tag>
        <el-tag type="danger" v-else size="mini">未发布</el-tag>
      </template>
      <template slot-scope="scope" slot="event_slot">
        <publishButton :moduleType="moduleType" :module_uuid="scope.row.version_uuid" @completed="getApiList"></publishButton>
        &nbsp;&nbsp;
        <viewPublish :id="scope.row.version_uuid" v-if="scope.row.is_published === '1'"
                     :module-type="moduleType"></viewPublish>
        &nbsp;&nbsp;
        <el-button type="text" @click="copy(scope.row.url)" size="mini">复制链接</el-button>
      </template>
    </vvTable>
    <el-dialog
      title="提示"
      :visible.sync="moduleuploadDialog"
      :before-close="handleClose"
      width="600">
      <el-form ref="moduleForm" :model="moduleForm" :rules="rules" label-width="80px">
        <el-form-item label="识别模块" prop="module_zip_url">
          <!--<el-input v-model="moduleForm.module_zip_url" placeholder="识别模块"></el-input>-->
          <el-upload
            class="upload-demo"
            action=""
            :http-request="modelUpload"
            :before-upload="handleBeforeUpload"
            accept="zip"
            :limit="1"
            :on-progress="onProgress"
            ref="apiUpload"
          >
            <el-button size="mini" type="primary">请上传识别模块</el-button>
            <el-tag type="success" v-if="uploading" size="mini"><i class="el-icon-loading"></i>上传中</el-tag>
          </el-upload>
        </el-form-item>
        <el-form-item label="版本号" prop="module_version">
          <!--<el-input size="mini" v-model="moduleForm.module_version" placeholder="版本号"></el-input>-->
          <el-autocomplete
            class="inline-input"
            v-model="moduleForm.module_version"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>

        <el-form-item label="模块备注" prop="module_desc">
          <el-input size="mini" v-model="moduleForm.module_desc" placeholder="模块备注"></el-input>
        </el-form-item>
        <el-form-item label="更新日志" prop="module_version_desc">
          <el-input size="mini" v-model="moduleForm.module_version_desc" placeholder="更新日志"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelUpload">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmUpload">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import aliOSSUpload from '@/lib/aliOSSUpload';
import vvTable from 'vue-virtual-table';
import md5 from 'js-md5';
import {apiGetApiModuleList, apiUploadApiZip} from '@/api';
import publishButton from './publishButton';
import viewPublish from '_c/viewPublish';

export default {
  name: 'zhiyanWssAdmin',
  components: {
    vvTable,
    publishButton,
    viewPublish
  },
  data () {
    return {
      loading: false,
      moduleType: 2,
      moduleList: [],
      rules: {
        module_zip_url: [{ required: true, message: "请上传识别模块zip" }],
        module_version: [{ required: true, message: "版本号不能为空" }]
      },
      moduleuploadDialog: false,
      moduleForm: {
        module_zip_url: "",
        module_desc: "",
        module_version_desc: '',
        module_version: "",
        module_zip_md5: ""
      }
    };
  },
  mounted () {
    this.getApiList();
  },
  methods: {
    ...mapMutations([
      'setSubTitle',
      'emitLoading',
      'removeLoading'
    ]),
    copy (text) {
      this.$copyText(text).then((e) => {
        this.$message.success('复制成功');
      }).catch((e) => {
        this.console.log(e);
        this.$message.error('复制失败' + e);
      });
    },
    onProgress (event) {
      this.emitLoading();
      console.log(event);
    },
    handleClose () {
      this.moduleuploadDialog = false;
      this.$refs['apiUpload'].clearFiles();
      this.$refs['moduleForm'].resetFields();
    },
    handleSelect () {

    },
    querySearch (val, cb) {
      let versions = this.api_version_list;
      cb(versions);
    },
    async confirmUpload () {
      this.$refs['moduleForm'].validate(async (valid) => {
        if (valid) {
          try {
            await apiUploadApiZip(this.moduleForm);
            this.getApiList();
            this.cancelUpload();
            this.$message.success('上传成功');
          } catch (e) {
            this.$message.error('上传失败' + e.message);
          }
        }
      });
    },
    cancelUpload () {
      this.handleClose();
    },
    async modelUpload(options) {
      let file = options.file;
      let name = file.name;
      const type = file.type;
      if (name.indexOf('zip') !== -1) {
        // 上传module
        // this.emitLoading();
        this.uploading = true;
        try {
          const {url} = await aliOSSUpload(
            {
              bucket: "zhiyan-app-upload",
              prefix: "zhiyan-app",
              name: file.name
            },
            file
          );
          this.$message.success("识别模块上传成功");
          this.moduleForm.module_zip_url = url;
          this.uploading = false;
          // this.removeLoading();
        } catch (e) {
          console.log(e);
          this.uploading = false;
          this.$message.error(e.message);
        }
      } else {
        this.$message.error('请上传zip文件');
        this.$refs['apiUpload'].clearFiles();
      }
    },
    computedMd5(file) {
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      let that = this;
      fileReader.onload = e => {
        let md5key = md5(e.target.result);
        that.moduleForm.module_zip_md5 = md5key;
        // return md5key;
      };
    },
    handleBeforeUpload(file) {
      this.computedMd5(file);
    },
    async getApiList () {
      try {
        const res = await apiGetApiModuleList();
        this.moduleList = res.api_info_list;
      } catch (e) {
        this.$message.error('获取识别模块列表失败' + e.message);
      }
    },
    ...mapActions([])
  },
  computed: {
    ...mapGetters(['api_version_list']),
    tableConfig () {
      return [
        { prop: "version", name: "版本号" },
        { prop: "_action", name: "更新日志", actionName: "version_desc_slot" },
        { prop: "_action", name: "上传日期", actionName: "date_slot" },
        { prop: "_action", name: "模块备注", actionName: "desc_slot" },
        { prop: "_action", name: "是否发布", actionName: "state_slot" },
        { prop: "_action", name: "操作", actionName: "event_slot", width: 300 }
      ];
    }
  },
  watch: {}
};
</script>
<style scoped lang="scss">
  .container {
    position: relative;
    .header-title {
      position: absolute;
      top: -90px;
      left: 200px;
      z-index: 1000;
    }
  }
</style>
